import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// 라우트 이동 시 스크롤 처리:
// - 해시(#section)가 있으면 해당 섹션으로 (홈 섹션이 렌더링될 때까지 잠시 재시도)
// - 없으면 페이지 맨 위로
export default function ScrollManager() {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0 });
      return;
    }
    const id = decodeURIComponent(hash.slice(1));
    let attempts = 0;
    const tryScroll = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView();
      } else if (attempts++ < 10) {
        setTimeout(tryScroll, 50);
      }
    };
    tryScroll();
  }, [pathname, hash, key]);

  return null;
}
